import { DocumentationPage } from './_article.jsx';
export default function CreatingAShowPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}